<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              modalWidth="80%"
              ref="master"
              :parentData="parentData"
              :key="key"
              :actions="false"
    >
    </g-master>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
      this.getColumsTable()
    },
    props: ['id_training'],
    data () {
      return {
        master: {
          endpoint: 'notas_x_participantes',
          tableSetup: {
            actions: {
              actions: false
            },
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: []
          }
        },
        key: 0
      }
    },
    methods: {
      getColumsTable () {
        this.httpClient.getInstance().get('notas_x_participantes_columns/' + this.id_training).then(response => {
          this.master.tableSetup.columns = response.data
          this.key++
        }).catch(error => {
          Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible consultar la información, contacte al administrador.'))
        })
      }
    },
    computed: {
      parentData () {
        return {
          id_training: this.id_training
        }
      }
    },
    watch: {
      id_training () {
        this.getColumsTable()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Capacitaciones/NotasXParticipantes.vue